import { QButton, useCurrentUser } from '@qualio/ui-components';
import { useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDocumentUpgradeInformation } from '../../../../../hooks/useDocumentUpgradeInformation';
import { DocumentUpgradePreviewModal } from '../../../DocumentUpgradePreviewModal/DocumentUpgradePreviewModal';
import { DocumentOverviewContext } from '../../Context';
import { shouldRenderApplyTemplateChangesButton } from '../../RenderLogic';

export const NewTemplateVersionAvailableButton = () => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();
  const { qualioDocument, refetchDocumentOverviewData } = useContext(
    DocumentOverviewContext,
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const canApplyTemplateChanges = useMemo(
    () => shouldRenderApplyTemplateChangesButton(qualioDocument, currentUser),
    [currentUser, qualioDocument],
  );

  const { data: documentUpgradeInformation } = useDocumentUpgradeInformation({
    canApplyTemplateChanges,
    documentId: qualioDocument.id,
  });

  if (!canApplyTemplateChanges || !documentUpgradeInformation?.can_upgrade) {
    return null;
  }

  return (
    <>
      <QButton
        onClick={() => setIsModalOpen(true)}
        variant="link"
        data-cy="new-template-version-available-button"
      >
        {t('buttons.newTemplateVersionAvailable')}
      </QButton>
      {isModalOpen && (
        <DocumentUpgradePreviewModal
          documentId={qualioDocument.id}
          companyId={currentUser.companyId}
          targetTemplate={documentUpgradeInformation.newest_template}
          currentTemplate={documentUpgradeInformation.current_template}
          onClose={() => setIsModalOpen(false)}
          onSuccess={() => refetchDocumentOverviewData()}
        />
      )}
    </>
  );
};
